import { render, staticRenderFns } from "./AgreementViewer.vue?vue&type=template&id=2abbed10&scoped=true&"
import script from "./AgreementViewer.vue?vue&type=script&lang=js&"
export * from "./AgreementViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbed10",
  null
  
)

export default component.exports